import React, { useState, useEffect } from "react";
import {
  Button,
  Card,
  Form,
  Input,
  Modal,
  Table,
  Pagination,
  message,
} from "antd";
import { get, post } from "../../apiService";
import { MdEmail } from "react-icons/md";
import { LockOutlined } from "@ant-design/icons";
import { FaEdit, FaPhoneAlt } from "react-icons/fa";
import { FaUserCircle } from "react-icons/fa";
import "./AdminStaff.css"; // Ensure this CSS file contains styles
import PrevilageUpdate from "./PrevilageUpdate";
import TitleComp from "./TitleComp";
import { FaUserCog } from "react-icons/fa";

const AdminStaff = () => {
  const [staffData, setStaffData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [openUpdate, setOpenUpdate] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [form] = Form.useForm();
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
    total: 0,
  });
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [searchInput, setSearchInput] = useState("");
  const [updateDetail, setUpdateDetail] = useState(null);
  const [formUpdate] = Form.useForm();

  // ====================== Fetch Team Detail ==============
  useEffect(() => {
    const dbounce = setTimeout(() => {
      fetchStaff(pagination.current, pagination.pageSize, searchInput);
    }, 300);
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
      clearTimeout(dbounce);
    };
  }, [pagination.current, pagination.pageSize, searchInput]);

  const fetchStaff = async (current, pageSize, search) => {
    setLoading(true);

    try {
      const action = "fetch";
      const type = "staff";
      const response = await get(
        `/user.php?action=${action}&limit=${pageSize}&page=${current}&type=${type}${
          search ? "&search=" + search + "" : ""
        }`
      );
      setStaffData(response.list);
      setPagination((prev) => ({
        ...prev,
        current,
        pageSize,
        total: response.total,
      }));
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };

  const handleTableChange = (newPagination) => {
    const { current, pageSize } = newPagination;

    setPagination((prev) => ({
      ...prev,
      current,
      pageSize,
    }));

    if (pageSize !== pagination.pageSize) {
      fetchStaff(1, pageSize);
    } else {
      fetchStaff(current, pageSize);
    }
  };

  const handleCancel = () => {
    setOpen(false);
  };

  const handleQuatationSend = async (value) => {
    setConfirmLoading(true);
    const formData = new FormData();
    formData.append("user_password", value.password);
    formData.append("user_email", value.email);
    formData.append("name", value.name);
    formData.append("number", value.number);
    formData.append("user_name", value.userName);
    formData.append("type", "staff");
    formData.append("action", "create_staff");

    try {
      const response = await post("/user.php", formData);
      if (response) {
        setOpen(false);
        form.resetFields();
        setStaffData((prev) => [
          ...prev,
          {
            user_id: response.id,
            name: value.name,
            user_email: value.email,
            number: value.number,
            user_name: value.userName,
          },
        ]);
        setOpen(false);
        setConfirmLoading(false);
        message.success("Team created successfully");
      } else {
        message.error("Username or email is already registered");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const handleUpdateStaff = async (value) => {
    setConfirmLoading(true);
    const formData = new FormData();
    formData.append("user_id", value.user_id);
    formData.append("user_password", value.password);
    formData.append("user_email", value.user_email);
    formData.append("name", value.name);
    formData.append("number", value.number);
    formData.append("user_name", value.user_name);
    formData.append("action", "update_profile");

    try {
      const response = await post("/user.php", formData);
      if (response) {
        const prevData = [...staffData]; // Create a shallow copy to avoid direct mutation
        const index = prevData.findIndex(
          (val) => val.user_id === value.user_id
        ); // Use strict equality

        if (index !== -1) {
          // Update the specific item in the array
          prevData[index] = {
            name: value.name,
            user_email: value.user_email,
            number: value.number,
            user_name: value.user_name,
          };

          setStaffData(prevData);
        }
        form.resetFields();
        setOpenUpdate(false);
        setConfirmLoading(false);
        setUpdateDetail(null);
        message.success("Team Updated successfully");
      } else {
        message.error("Username or email is already registered");
      }
    } catch (error) {
      console.log(error);
    }
  };
  const onFinishFailed = (error) => {
    console.log(error);
  };

  const columns = [
    { title: "Staff ID", dataIndex: "user_id", key: "user_id" },

    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Username",
      dataIndex: "user_name",
      key: "user_name",
    },
    {
      title: "Email",
      dataIndex: "user_email",
      key: "user_email",
    },
    {
      title: "Action",
      dataIndex: "action",
      key: "action",
      render: (_, record) => {
        return (
          <div className="d-flex">
            <PrevilageUpdate data={record} />{" "}
            <Button
              icon={<FaEdit />}
              className="bg-warning text-dark mx-3"
              style={{ height: "35px" }}
              onClick={() => {
                setUpdateDetail(record);
                setOpenUpdate(true);
              }}
            >
              Update Team
            </Button>
          </div>
        );
      },
    },
  ];

  const debounce = (func, delay) => {
    let timerId;
    return (...args) => {
      if (timerId) {
        clearTimeout(timerId);
      }
      timerId = setTimeout(() => func(...args), delay);
    };
  };

  const checkAvailability = debounce(async (type, value) => {
    if (type === "number" && value.length !== 10) {
      message.error("Phone number must be exactly 10 digits.");
      return;
    }

    if (type === "user_email" && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      message.error("Invalid email format.");
      return;
    }

    const formData = new FormData();
    formData.append("typeCheck", type);
    formData.append("typeValue", value);
    formData.append("type", "user");
    formData.append("action", "checkInputDetail");

    try {
      const response = await post("/user.php", formData);
      if (response.status === 200) {
        message.success(
          `${type.charAt(0).toUpperCase() + type.slice(1)} is available.`
        );
      }
    } catch (error) {
      message.error(
        `${type.charAt(0).toUpperCase() + type.slice(1)} is already registered.`
      );
    }
  }, 500);

  useEffect(() => {
    if (updateDetail) {
      formUpdate.setFieldsValue(updateDetail);
    }
  }, [updateDetail]);

  return (
    <>
      <div className="component-container">
        <TitleComp
          name="Team's List"
          type="Team"
          totalData={pagination.total}
          button={
            <Button
              icon={<FaUserCog />}
              className="bg-dark text-white"
              style={{ height: "35px" }}
              onClick={() => setOpen(true)}
            >
              Add Team
            </Button>
          }
          setSearchInput={setSearchInput}
        />

        {isMobile ? (
          <div className="component-card-container">
            {staffData?.map((staff) => (
              <Card
                key={staff.user_id}
                title={`User ID: ${staff.user_id}`}
                extra={
                  <div className="d-flex">
                    <PrevilageUpdate data={staff} />{" "}
                    <Button
                      icon={<FaEdit />}
                      className="bg-warning text-dark"
                      style={{ height: "35px", marginLeft:"10px"}}
                      onClick={() => {
                        setUpdateDetail(staff);
                        setOpenUpdate(true);
                      }}
                    >
                      Update
                    </Button>
                  </div>
                }
                className="component-card"
              >
                <p>Name: {staff.name}</p>
                <p>Username: {staff.user_name}</p>
                <p>Email: {staff.user_email}</p>
              </Card>
            ))}
            <Pagination
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              onChange={(page, pageSize) =>
                handleTableChange({ current: page, pageSize })
              }
              className="component-pagination"
            />
          </div>
        ) : (
          <div className="component-table-container">
            <Table
              columns={columns}
              dataSource={staffData}
              pagination={false}
              loading={loading}
              onChange={handleTableChange}
              scroll={{ x: "max-content" }}
              className="component-table"
            />
            <Pagination
              current={pagination.current}
              pageSize={pagination.pageSize}
              total={pagination.total}
              onChange={(page, pageSize) =>
                handleTableChange({ current: page, pageSize })
              }
              className="component-pagination"
            />
          </div>
        )}

        <Modal
          title="Add New Staff"
          open={open}
          confirmLoading={confirmLoading}
          onCancel={handleCancel}
          footer={null}
          className="component-modal"
        >
          <Form
            form={form}
            layout="vertical"
            name="registration"
            autoComplete="off"
            initialValues={{ remember: true }}
            onFinish={handleQuatationSend}
            onFinishFailed={onFinishFailed}
          >
            <div className="row">
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "This field is required." }]}
              >
                <Input
                  name="name"
                  className="component-input"
                  placeholder="Name"
                />
              </Form.Item>
              <div className="col-md-6">
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "This field is required.",
                    },
                  ]}
                >
                  <Input
                    name="email"
                    placeholder="Email Id"
                    onChange={(e) =>
                      checkAvailability("user_email", e.target.value)
                    }
                    prefix={<MdEmail />}
                    className="component-input"
                  />
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item
                  label="Number"
                  name="number"
                  rules={[
                    { required: true, message: "This field is required." },
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.reject(
                            new Error("Phone number is required.")
                          );
                        }
                        if (value.toString().length !== 10) {
                          return Promise.reject(
                            new Error("Phone number must be exactly 10 digits.")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    prefix={<FaPhoneAlt />}
                    name="number"
                    className="component-input"
                    placeholder="Phone Number"
                    style={{ minHeight: "40px" }}
                  />
                </Form.Item>
              </div>
              <Form.Item
                label="Username"
                name="userName"
                rules={[{ required: true, message: "This field is required." }]}
              >
                <Input
                  name="username"
                  prefix={<FaUserCircle />}
                  onChange={(e) =>
                    checkAvailability("user_name", e.target.value)
                  }
                  className="component-input"
                  placeholder="Username"
                />
              </Form.Item>
              <div className="col-md-6">
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[{ required: true, message: "Password is required." }]}
                  hasFeedback
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    className="component-input"
                    placeholder="Password"
                  />
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item
                  label="Confirm Password"
                  name="confirm"
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password.",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The two passwords you entered do not match."
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    className="component-input"
                    placeholder="Confirm Password"
                  />
                </Form.Item>
              </div>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="component-submit-btn bg-dark"
                >
                  Add Staff
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Modal>
        <Modal
          title="Update Team"
          open={openUpdate}
          confirmLoading={confirmLoading}
          onCancel={() => setOpenUpdate(false)}
          footer={null}
          className="component-modal"
        >
          <Form
            form={formUpdate}
            layout="vertical"
            name="registration"
            autoComplete="off"
            initialValues={{ remember: true }}
            onFinish={handleUpdateStaff}
            onFinishFailed={onFinishFailed}
          >
            <div className="row">
              <Form.Item className="d-none" name="user_id">
                <Input />
              </Form.Item>
              <Form.Item
                label="Name"
                name="name"
                rules={[{ required: true, message: "This field is required." }]}
              >
                <Input
                  name="name"
                  className="component-input"
                  placeholder="Name"
                />
              </Form.Item>
              <div className="col-md-6">
                <Form.Item
                  label="Email"
                  name="user_email"
                  rules={[
                    {
                      required: true,
                      type: "email",
                      message: "This field is required.",
                    },
                  ]}
                >
                  <Input
                    name="email"
                    placeholder="Email Id"
                    onChange={(e) =>
                      checkAvailability("user_email", e.target.value)
                    }
                    prefix={<MdEmail />}
                    className="component-input"
                  />
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item
                  label="Number"
                  name="number"
                  rules={[
                    { required: true, message: "This field is required." },
                    {
                      validator: (_, value) => {
                        if (!value) {
                          return Promise.reject(
                            new Error("Phone number is required.")
                          );
                        }
                        if (value.toString().length !== 10) {
                          return Promise.reject(
                            new Error("Phone number must be exactly 10 digits.")
                          );
                        }
                        return Promise.resolve();
                      },
                    },
                  ]}
                >
                  <Input
                    prefix={<FaPhoneAlt />}
                    name="number"
                    className="component-input"
                    placeholder="Phone Number"
                    style={{ minHeight: "40px" }}
                  />
                </Form.Item>
              </div>
              <Form.Item
                label="Username"
                name="user_name"
                rules={[{ required: true, message: "This field is required." }]}
              >
                <Input
                  name="username"
                  prefix={<FaUserCircle />}
                  onChange={(e) =>
                    checkAvailability("user_name", e.target.value)
                  }
                  className="component-input"
                  placeholder="Username"
                />
              </Form.Item>
              <div className="col-md-6">
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[{ required: true, message: "Password is required." }]}
                  hasFeedback
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    className="component-input"
                    placeholder="Password"
                  />
                </Form.Item>
              </div>
              <div className="col-md-6">
                <Form.Item
                  label="Confirm Password"
                  name="confirm"
                  dependencies={["password"]}
                  hasFeedback
                  rules={[
                    {
                      required: true,
                      message: "Please confirm your password.",
                    },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error(
                            "The two passwords you entered do not match."
                          )
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password
                    prefix={<LockOutlined />}
                    className="component-input"
                    placeholder="Confirm Password"
                  />
                </Form.Item>
              </div>
              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="component-submit-btn bg-dark"
                >
                  Update Staff
                </Button>
              </Form.Item>
            </div>
          </Form>
        </Modal>
      </div>
    </>
  );
};

export default AdminStaff;
